module.exports = __webpack_public_path__ + "img/icon_contact.c5ab3012.svg";